const useHost = () => {
    const host = location.host.toLowerCase();
    if (host.includes("scored.co")) return "scored.co";
    if (host.includes("communities.win")) return "communities.win";
    if (host.includes("patriots.win")) return "patriots.win";
    return "";
}

export const useScoredMedia = (link) => {

    if (!link) return false;
    try {

        const url = new URL(link).hostname;
        const validUrls = ['media.scored.co', 'media.communities.win',
            'media.patriots.win', 'media.greatawakening.win', 'media.kotakuinaction2.win'];

        return validUrls.includes(url);

    } catch (e) {
        return false;
    }

};


export default useHost;